import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Card } from "../../../../Card";
import { Header } from "../../Header";
import { Sharing } from "../../Sharing";
import { CompactParameters } from "../../CompactParameters";
import { TopParameters } from "../../TopParameters";
import { Description } from "../../Description";
import { Parameters } from "../../Parameters";
import { Footer } from "../../Footer";
import { Values } from "../../Values";
import { Wait } from "../../Wait";
import { Half } from "../Half";
import { useShouldDisplayHalfCard } from "../hooks/useShouldDisplayHalfCard";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Wide = /*#__PURE__*/memo(function (props) {
  var _props$compactParamet, _props$topParameters, _props$parameters;
  /* Условие для показа Half карточки */
  var shouldDisplayHalfCard = useShouldDisplayHalfCard();
  if (shouldDisplayHalfCard) return /*#__PURE__*/React.createElement(Half, _extends({}, props, {
    cardType: "half",
    "data-t-id": "CardTypes-Wide"
  }));
  return /*#__PURE__*/React.createElement(Card, {
    className: cn('wide', {
      'wide--wait': props.isLoading || props.isError
    }),
    tagName: "div",
    withHover: true
  }, (props.isLoading || props.isError) && /*#__PURE__*/React.createElement(Wait, {
    isError: props.isError,
    isLoading: props.isLoading,
    onError: props.onError
  }), !props.isError && !props.isLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('wide__header', {
      'wide__header--dark': props.isDark
    }),
    style: {
      backgroundImage: "url('".concat(props.bgImage, "')")
    }
  }, /*#__PURE__*/React.createElement(Header, {
    availableOnlyInOffice: props.availableOnlyInOffice,
    badge: props.badge,
    cardType: props.cardType,
    connectedSettings: props.connectedSettings,
    discount: props.discount,
    forEsim: props.forEsim,
    isConnected: props.isConnected,
    isDark: props.isDark,
    title: props.title,
    titleSize: "size4-r"
  }), /*#__PURE__*/React.createElement(Sharing, {
    badgeClassName: cn('badge'),
    cardType: props.cardType,
    isLast: props.isLast,
    isYandex: props.isYandex,
    sharing: props.sharing
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('wide__body')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('wide-body-left')
  }, props.packages && /*#__PURE__*/React.createElement(Values, {
    cardType: props.cardType,
    isDark: false,
    packages: props.packages
  }), props.compactParameters && ((_props$compactParamet = props.compactParameters) === null || _props$compactParamet === void 0 ? void 0 : _props$compactParamet.length) > 0 && /*#__PURE__*/React.createElement(CompactParameters, {
    compactParameters: props.compactParameters,
    isDark: props.isDark,
    isFirst: props.isFirst,
    isYandex: props.isYandex
  }), props.topParameters && ((_props$topParameters = props.topParameters) === null || _props$topParameters === void 0 ? void 0 : _props$topParameters.length) > 0 && /*#__PURE__*/React.createElement(TopParameters, {
    parameters: props.topParameters
  }), /*#__PURE__*/React.createElement(Description, {
    description: props.description
  }), ((_props$parameters = props.parameters) === null || _props$parameters === void 0 ? void 0 : _props$parameters.length) > 0 && /*#__PURE__*/React.createElement(Parameters, {
    cardType: "wide",
    parameters: props.parameters
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('wide-body-right')
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonClassName: props.buttonClassName,
    buttonText: props.buttonText,
    cardType: props.cardType,
    discount: props.discount,
    isConstructor: props.isConstructor,
    link: props.link,
    onLinkClick: props.onLinkClick,
    price: props.price,
    priceClassName: cn('price'),
    priceNotLoaded: props.priceNotLoaded,
    priceNotLoadedCallback: props.priceNotLoadedCallback
  })))));
});